import { DialogClose } from "@radix-ui/react-dialog";
import { ReactNode } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "./dialog";

interface SubmitExamDialogProps {
  children: ReactNode;
  onClick: () => void;
}

const SubmitExamDialog = ({ children, onClick }: SubmitExamDialogProps) => {
  return (
    <Dialog>
      <DialogTrigger>{children}</DialogTrigger>
      <DialogContent className="bg-white">
        <DialogHeader>
          <DialogTitle>Are you sure want to SUBMIT the Exam ?</DialogTitle>
        </DialogHeader>
        <div className="flex justify-between space-y-1">
          <DialogClose>
            <button className="inline-flex h-9 items-center justify-center whitespace-nowrap rounded-md border border-gray-600 bg-gray-300/80 px-4 py-2 text-sm font-medium transition-colors hover:bg-gray-300/50 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50">
              Review
            </button>
          </DialogClose>
          <DialogClose>
            <button
              className="inline-flex h-9 items-center justify-center whitespace-nowrap rounded-md bg-primary px-4 py-2 text-sm font-medium text-white transition-colors hover:border hover:border-primary hover:bg-[#8B70D7]/60 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50"
              onClick={onClick}
            >
              Submit
            </button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SubmitExamDialog;
